import { LabelTypeMetadata } from "@/models/NutritionLabels/LabelTypeMetadata";
import { NutritionLabelCountry } from "@/models/NutritionLabels/NutritionLabelCountry";
import {
  NutritionLabelRoundingProfile,
  type NutritionLabelRoundingProfileValue,
} from "@/models/NutritionLabels/v2/enums/NutritionLabelRoundingProfile";

const FSIS_ROUNDING_RULE_INDEXES = [1, 2];

export type LabelRoundingProfileFilterArgs = {
  selectedLabelTypeValue?: string | null;
  preselectedLabelType?: LabelTypeMetadata | null;
  countryId?: number | null;
  roundingRuleIndex?: number | null;
};

export function isSupplementLabelTemplate(
  selectedLabelTypeValue?: string | null,
  preselectedLabelType?: LabelTypeMetadata | null,
): boolean {
  const normalizedTemplate = (selectedLabelTypeValue || "").toLowerCase();

  return normalizedTemplate.includes("supplement")
    || preselectedLabelType === LabelTypeMetadata.SupplementFacts;
}

export function getLabelRoundingProfileFilter({
  selectedLabelTypeValue,
  preselectedLabelType,
  countryId,
  roundingRuleIndex,
}: LabelRoundingProfileFilterArgs): NutritionLabelRoundingProfileValue {
  const isSupplementTemplate = isSupplementLabelTemplate(
    selectedLabelTypeValue,
    preselectedLabelType,
  );

  if (isSupplementTemplate) {
    return NutritionLabelRoundingProfile.Supplement;
  }

  if (countryId !== NutritionLabelCountry.US) {
    return NutritionLabelRoundingProfile.Standard;
  }

  if (FSIS_ROUNDING_RULE_INDEXES.includes(roundingRuleIndex || 0)) {
    return NutritionLabelRoundingProfile.Fsis;
  }

  return NutritionLabelRoundingProfile.Standard;
}

export function isSupplementCheckboxDisabled(
  countryId?: number | null,
  roundingRuleId?: number | null,
): boolean {
  return countryId === NutritionLabelCountry.US
    && FSIS_ROUNDING_RULE_INDEXES.includes(roundingRuleId || 0);
}

export function getSupplementCheckboxStateAfterRoundingRuleChange(
  isSupplementSelected: boolean,
  countryId?: number | null,
  roundingRuleId?: number | null,
): boolean {
  return isSupplementCheckboxDisabled(countryId, roundingRuleId)
    ? false
    : isSupplementSelected;
}